import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullOrderDetailsComponent } from './full-order-details/full-order-details.component';
import { ErrorPageComponent } from './Views/error-page/error-page.component';
import { ViewAllNotificationsComponent } from './Views/notification/view-all-notifications/view-all-notifications/view-all-notifications.component';
import { OrderStatusComponent } from './Views/order-status/order-status.component';
import { RegValidationComponent } from './Views/reg-validation/reg-validation.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'authenticate',
    pathMatch: 'full'
  },
  {
    path: `authenticate`,
    component: RegValidationComponent,
  },
  {
    path: `order-status`,
    component: FullOrderDetailsComponent,
    children: [
      {
         path: ``,
         component: OrderStatusComponent,
       }]
  },
  {
    path: `view-all-notifications`,
    component: ViewAllNotificationsComponent,
    // children: [
    //   {
    //      path: ``,
    //      component: ViewNotificationDetailsComponent,
    //    }]
  }

  // {
  //   path: `car-parking`,
  //   component: CarParkingComponent,
  // },
  // {
  //   path: 'notification',
  //   data: {
  //     title: 'Parking'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       component: NotificationComponent
  //     },
  //     {
  //       path: ':id',
  //       component: ViewNotificationComponent,
  //       data: {
  //         title: 'View Notification'
  //       },
  //     }
  //   ]
  // },
  , { path: 'error-page', component: ErrorPageComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
